import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// API helpers for receipts and invoices of paid memberships and licences. Amounts, tax and seller details come from the
// server (copied into the document when the payment succeeded); nothing here calculates money.
const url = (path) => `${API_BASE_URL}/v1/purchase-document/${path}`;
const config = (extra = {}) => ({ headers: { token: getAuthToken(), "Content-Type": "application/json" }, timeout: 20000, ...extra });
const result = (response) => response.data?.result;

export const receiptApi = {
  // source_type: "membership" | "licence"; source_id: the subscription or licence id.
  bySource: (sourceType, sourceId) => axios.get(url("by-source"), config({ params: { source_type: sourceType, source_id: sourceId } })).then(result),
  // The PDF as a file the browser saves. The token travels in the header, so a plain link cannot be used.
  downloadPdf: async (doc) => {
    const response = await axios.get(url(`${encodeURIComponent(doc.id)}/pdf`), config({ responseType: "blob", timeout: 30000 }));
    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    link.href = href;
    link.download = `${doc.document_number || "receipt"}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(href), 1000);
  },
};

export const receiptLink = (sourceType, sourceId) => `/receipts/${sourceType}/${sourceId}`;
